<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="ch05"></a><a id="page_5"></a><a href="#/contents#ch05"><b>Too Cool for School</b></a></h2>
<p class="noindent"><span>Chuck Berry has a degree from a beauty school.</span></p>
<p class="noindent"><span>Tony Blair’s schoolmaster called him “the most difficult boy I ever had to deal with.”</span></p>
<p class="noindent"><span>Singer Huey Lewis scored a perfect 800 on the math portion of his SAT.</span></p>
<p class="noindent"><span>Philosopher and author Eric Hoffer (<i>The True Believer</i>, published in 1951) was self-educated. He was homeless for many years, and then worked as a dishwasher and longshoreman.</span></p>
<p class="noindent"><span>Gene Simmons of KISS was once an elementary school teacher.</span></p>
<p class="noindent"><span>Garth Brooks’s college major: advertising.</span></p>
<p class="noindent"><span>Al Capone dropped out of school when he was 14.</span></p>
<p class="noindent"><span>Jack Nicholson spent every day of an entire school year in detention.</span></p>
<p class="noindent"><span>In high school, Mariah Carey’s nickname was “Mirage” because she was absent so often.</span></p>
<p class="noindent"><span>Monica Lewinsky’s classmates voted her “Most Likely to Get Her Name in Lights.”</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter05.vue?3eaec142